import { render, staticRenderFns } from "./AttributeFieldSelectItem.vue?vue&type=template&id=085fff8d&scoped=true"
import script from "./AttributeFieldSelectItem.vue?vue&type=script&lang=js"
export * from "./AttributeFieldSelectItem.vue?vue&type=script&lang=js"
import style0 from "./AttributeFieldSelectItem.vue?vue&type=style&index=0&id=085fff8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085fff8d",
  null
  
)

export default component.exports